
import { useCallback } from 'react';
import { logger } from '@/services/LoggingService';
import { VezgoCallbackResult } from '../types';

/**
 * Hook for managing progress updates and callback processing
 * Handles progress tracking and callback result management
 */
export function useVezgoProgress(vezgoActions) {
  const updateProgress = useCallback((progress: number) => {
    logger.debug('useVezgoState', 'Updating processing progress', { progress });
    
    const safeProgress = Math.max(0, Math.min(100, progress));
    
    if (vezgoActions.setProcessingProgress) {
      vezgoActions.setProcessingProgress(safeProgress);
    }
  }, [vezgoActions]);

  const processCallbackData = useCallback((result: VezgoCallbackResult) => {
    logger.info('useVezgoState', 'Processing callback data', {
      success: result.success,
      provider: result.provider
    });
    
    if (vezgoActions.setCallbackResult) {
      vezgoActions.setCallbackResult(result);
    }
  }, [vezgoActions]);

  return {
    updateProgress,
    processCallbackData
  };
}
